import styled from "styled-components";
import { STYLE_CONSTS } from "~/src/styles/config.style";

export default styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.neutral.main};
  margin-top: ${STYLE_CONSTS.UNIT_3};
  margin-bottom: ${STYLE_CONSTS.UNIT_4};
  width: ${({ width }) => (width ? `${width}px` : "100%")};
`;
